import React, { useState } from 'react';

import {
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  Stack,
} from '@gogame/components';

import {
  useConcept,
  useConceptDetails,
} from 'scenes/Gallery/GalleryPage/Concepts/data';
import { useCreative } from 'scenes/Gallery/GalleryPage/Creatives/data';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';

import PrefillFieldsDialog from 'scenes/Gallery/components/PrefillFieldsDialog';

export const PREFILL_CONCEPT_AND_CREATIVE = 'conceptAndCreative';
export const PREFILL_CONCEPT = 'concept';

const ConceptPrefillFieldsDialog = ({ open, onSubmit, onExited, onClose }) => {
  const [conceptId, setConceptId] = useState('');

  const [prefillFieldFor, setPrefillFieldFor] = useState(
    PREFILL_CONCEPT_AND_CREATIVE
  );

  const {
    data: conceptData,
    isLoading: loadingConcept,
    error: errorConcept,
  } = useConcept({ id: conceptId }, { enabled: Boolean(conceptId) });

  const { data: conceptDetailsData } = useConceptDetails(
    { id: conceptId },
    { enabled: Boolean(conceptId) }
  );

  const conceptOriginalId =
    conceptDetailsData?.[CONCEPT.ORIGINAL]?.[CREATIVE.ID];

  const {
    data: conceptOriginalData,
    isLoading: loadingConceptOriginal,
    error: errorConceptOriginal,
  } = useCreative(
    { id: conceptOriginalId },
    { enabled: Boolean(conceptOriginalId) }
  );

  const handleChangeConceptId = (_, value) => {
    setConceptId(value);
  };

  const handleChangePrefillFieldFor = (_, value) => {
    setPrefillFieldFor(value);
  };

  const handleSubmit = () => {
    onSubmit({
      conceptData,
      conceptOriginalData,
      prefillFieldFor,
    });
  };

  return (
    <PrefillFieldsDialog
      title={'Enter the ID of the Concept to prefill fields from.'}
      filedLabel={'ID'}
      open={open}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      id={conceptId}
      onChangeId={handleChangeConceptId}
      disabledConfirmAction={
        !(conceptData && conceptOriginalData) ||
        loadingConcept ||
        loadingConceptOriginal
      }
      error={Boolean(errorConcept || errorConceptOriginal)}
    >
      <Stack spacing={0.5}>
        <Typography color={'textSecondary'}>Prefill field for</Typography>
        <ToggleButtonGroup
          value={prefillFieldFor}
          onChange={handleChangePrefillFieldFor}
        >
          <ToggleButton value={PREFILL_CONCEPT_AND_CREATIVE}>
            Concept And Creative
          </ToggleButton>
          <ToggleButton value={PREFILL_CONCEPT}>Concept</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </PrefillFieldsDialog>
  );
};

export default ConceptPrefillFieldsDialog;
